export default __webpack_public_path__ + "static/media/features-split-image-01.94b14c16.png";